import {Column} from '../../../../widgets/TablesComponents/AdvancedTable'
import {RegistroReclamaciones} from '../../../models/_models'

export const columnasReclamaciones: Column<RegistroReclamaciones>[] = [
  {
    key: 'IdReclamo',
    label: 'Id',
    type: 'number',
    className: 'min-w-50px  ps-4',
    id: true,
  },
  {
    key: 'Nombres',
    label: 'Nombres',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'Apellidos',
    label: 'Apellidos',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'Email',
    label: 'Email',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'Telefono',
    label: 'Telefono',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'TipoDocumento',
    label: 'Tipo de Documento',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'NumDocumento',
    label: 'Número de Documento',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'Direccion',
    label: 'Dirección',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'Ciudad',
    label: 'Ciudad',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'Pais',
    label: 'País',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'TipoReclamo',
    label: 'Tipo de Reclamo',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'FechaIncidencia',
    label: 'Fecha de Incidencia',
    type: 'date',
    className: 'min-w-200px',
  },
  {
    key: 'Detalle',
    label: 'Detalle',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'Pedido',
    label: 'Pedido',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'TipoBienContratado',
    label: 'Tipo de Bien Contratado',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'PadreOMadre',
    label: 'Padre o Madre',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'MontoReclamo',
    label: 'Monto de Reclamo',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'Descripcion',
    label: 'Descripcion',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'FechaRespuesta',
    label: 'Fecha de Respuesta',
    type: 'date',
    className: 'min-w-200px',
  },
  {
    key: 'RespuestaAcciones',
    label: 'Respuesta Acciones',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'estatus.Descripcion',
    label: 'Estatus',
    type: 'string',
    className: 'min-w-200px',
    render: (row) => row.estatus?.Descripcion ?? '',
  },
  {
    key: 'orgventas_x_locales.Sede',
    label: 'Sede',
    type: 'string',
    className: 'min-w-200px',
    render: (row) => row.orgventas_x_locales?.Sede ?? '',
  },
  {
    key: 'Activo',
    label: 'Activo',
    type: 'boolean',
    className: 'min-w-100px ps-4 ',
  },
  {key: 'CreadoPor', label: 'Creado Por', type: 'string', className: 'min-w-100px'},
  {key: 'CreadoEl', label: 'Creado El', type: 'date', className: 'min-w-150px'},
  {key: 'ModificadoPor', label: 'Modificado Por', type: 'string', className: 'min-w-150px'},
  {key: 'ModificadoEl', label: 'Modificado El', type: 'date', className: 'min-w-150px'},
]
